import { cn } from '../lib/cn'
import { PulseDot } from './PulseDot'

interface LogoProps {
  className?: string
  showSubtitle?: boolean
  /** When set, the logo becomes a link (e.g. back to the marketing landing). */
  href?: string
}

export function Logo({ className, showSubtitle = false, href }: LogoProps) {
  const content = (
    <>
      <PulseDot size="sm" label="alerte-immo" />
      <span className="font-semibold tracking-tight">alerte-immo</span>
      {showSubtitle ? (
        <span className="font-mono text-[10px] uppercase tracking-widest text-muted">
          off-market
        </span>
      ) : null}
    </>
  )

  if (href) {
    return (
      <a
        href={href}
        className={cn(
          'inline-flex items-center gap-2.5 rounded-sm hover:opacity-80 transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          className,
        )}
      >
        {content}
      </a>
    )
  }

  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>{content}</span>
  )
}
